module.exports = __webpack_public_path__ + "media/images/600_500_A-856ddcae927f27f11a9d2defd2b4dea1.png";